import { GenericEventValues } from '../types/analytics.type'

export enum BootcampEvents {
  // Info Page Related Events
  CLICKED_AND_UNDERSTOOD = 'click_and_understood',
  CHECK_ANSWER = 'check_answer',
  CLICKED_HELP = `click_help`,
  CLICKED_PREREQUISITES_DROPDOWN = `click_prerequisite_dropdown`,
  CLICKED_ACTIVITY_MENU_DROPDOWN = `click_activity_menu_dropdown`,

  // Activity Page Related Events
  ACTIVITY_TYPE_CHANGE = 'change_activity_type',

  // Boss Fight related
  BOSS_FIGHT_STARTED = 'boss_fight_start',
  BOSS_FIGHT_RESTARTED = 'boss_fight_restart',
  BOOS_FIGHT_QUIT = 'quit_boss_fight',
  WIN_BOSS_BATTLE = 'won_boss_battle',
  LOST_BOSS_BATTLE = 'lost_boss_battle',
  BOSS_FIGHT_CHECK_ANSWER = 'boss_fight_check_answer',

  // Upcoming bootcamp entities
  CLICK_UPCOMING_CATEGORY = 'click_upcoming_category',
  CLICK_UPCOMING_SUBJECT = 'click_upcoming_subject',
  CLICK_UPCOMING_BOOTCAMP = 'click_upcoming_bootcamp',
  CLICK_FUN_FACT_CHEST = 'open_fun_fact_chest',

  // Curriculum related
  TOGGLE_SWITCH = 'toggle_switch',
  SELECTED_TOPIC = 'select_topic',
}

export enum ActivityMenuStatus {
  OPENED = 'open',
  CLOSED = 'close',
}
export const BCAEvent = {
  ...BootcampEvents,
  weight: {
    ...GenericEventValues,
  },
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type BootcampPathObject = {
  activity_name?: string
  bootcamp?: string
  bootcamp_page_type?: string
  category?: string
  key?: string
  level?: string
  locale?: string
  page?: string
  status?: string
  subject?: string
  title?: string
}
